import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Stripe from "./Stripe";
import { stripe_publishable_id } from "../../../constants";
import { ReactComponent as CloseIcon } from "./../../../assets/images/cross.svg";
import Overlay from "../../Utils/Overlay";

const StripePaymentProvider = ({
  clientSecret,
  close,
  setLoading,
  isSetup,
  redirectUrl,
  amountLabel = "",
  onPaymentFail = () => { }
}) => {
  const stripePromise = loadStripe(stripe_publishable_id);

  useEffect(() => {
    setLoading(false);
  }, []);

  const options = {
    clientSecret: clientSecret,
  };

  return ReactDOM.createPortal(
    <div className="payment-service-modal">
      <Overlay darkTheme={true} handleOnClick={close} />
      <div className="popup payment-popup payment-popup--stripe">
        <CloseIcon className="popup__close" onClick={close} />
        <div className="popup__body" style={{ padding: "4rem" }}>
          {!isSetup && amountLabel && (
            <div className="stripe-payment__header">
              <p className="stripe-payment__amount-label">Amount to pay</p>
              <h3 className="stripe-payment__amount">{amountLabel}</h3>
            </div>
          )}
          <Elements stripe={stripePromise} options={options}>
            <Stripe
              isSetup={isSetup}
              redirectUrl={redirectUrl}
              onPaymentFail={onPaymentFail}
            />
          </Elements>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StripePaymentProvider;
